var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ticket-feed-provider',[_c('box',[_c('ticket-message-form',{staticClass:"has-margin-bottom-100",attrs:{"disabled":_vm.ticketData.isStaged}}),_vm._v(" "),_c('ticket-messages')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }